export const space = (spacing: number, base: number): number => spacing * base
